module.exports = __webpack_public_path__ + "static/media/berlin.599ab874.jpg";